let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let dateformat = require("ES/lib/dateformat");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let getPastNMonths = function(n_months){
	let date = new Date();
	date.setDate(1);
	date.setHours(0);
	return _.map(_.range(0, n_months), function(){
		let m = {
			name: dateformat(date, "mmmm yyyy"),
			year: esUtils.toInt(dateformat(date, "yyyy")),
			month: esUtils.toInt(dateformat(date, "m"))
		};
		date.setMonth(date.getMonth() - 1);
		return m;
	});
};

let MonthToggle = dd.createClass({
	__onClick: esUtils.wrapPreventDefault(function(){
		let {year, month, toggleMonth} = this.props;
		toggleMonth(year, month);
	}),
	render(){
		let {name, is_locked, is_loading} = this.props;
		let classes = ["fa"];
		if(is_loading){
			classes.push("fa-spinner");
			classes.push("fa-spin");
		}else if(is_locked){
			classes.push("fa-unlock");
			classes.push("text-warning");
		}else{
			classes.push("fa-lock");
			classes.push("text-success");
		}
		return dd.a({href: "#", className: "list-group-item", onClick: this.__onClick},
			dd.span({style: {display: "inline-block", width: "1.5em", fontSize: "1.5em"}},
				dd.i({className: classes.join(" ")})
			),
			" " + name
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	getInitialState(){
		return {last_month_clicked: null, month_data: null};
	},
	RadioService_setup(){
		return {
			AccountingLock_read: {key: "callService", on: {
				succeeded(data){
					this.setState({month_data: data});
				}
			}},
			AccountingLock_toggle: {key: "callService", on: {
				succeeded(data){
					this.setState({month_data: data});
				}
			}}
		};
	},
	componentDidMount(){
		this.RadioService_callService("AccountingLock_read");
	},
	__toggleMonth(year, month){
		this.setState({last_month_clicked: year+"-"+month});
		this.RadioService_callService("AccountingLock_toggle", {year, month});
	},
	render(){
		let {Displaylists} = this.props;
		let ajax_read = this.state.AccountingLock_read;
		let ajax_toggle = this.state.AccountingLock_toggle;
		let {last_month_clicked, month_data} = this.state;

		return LoadingWrap({is_loading: _.isEmpty(Displaylists) || ajax_read.waiting || ajax_toggle.waiting, glass: true},
			ErrorAlert({message: ajax_read.error}),
			ErrorAlert({message: ajax_toggle.error}),
			dd.h2({style: {marginTop: 0}}, "Click the lock icon next to a month to change accounting lock status."),
			dd.div({className: "row"},
				dd.div({className: "col-sm-1"}),
				dd.div({className: "col-sm-4"},
					dd.div({className: "list-group"},
						_.map(getPastNMonths(60), function({year, month, name}){
							return MonthToggle({
								key: name,
								name, year, month,
								is_locked: _.isEmpty(esUtils.getIn(month_data, [year, month])),
								is_loading: (ajax_read.waiting || ajax_toggle.waiting) && (last_month_clicked === null || (last_month_clicked === (year+"-"+month))),
								toggleMonth: this.__toggleMonth
							});
						}, this)
					)
				)
			),
			dd.div({className: "clearfix"})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/account_settings/AccountingLock/index.js